import React from "react";
import { FieldError } from "react-hook-form";

import styles from "./styles.module.scss";

export interface IComponentProps {
  error?: FieldError;
  label?: string;
  lines?: number;
  inputRef?: any;
}

type Props = IComponentProps & React.HTMLProps<HTMLInputElement>;

const Input: React.FC<Props> = ({
  label,
  lines,
  error,
  inputRef,
  ...props
}) => {
  const renderLabel = () => {
    if (label) {
      return <label>{label}</label>;
    }
  };

  return (
    <div className={styles.container}>
      {renderLabel()}
      {lines ? (
        <textarea ref={inputRef} rows={lines} id={props.id} name={props.name} />
      ) : (
        <input ref={inputRef} type="text" {...props} />
      )}
      {error && error.type === "required" && <small>*Required input</small>}
      {error && <small>{error.message}</small>}
    </div>
  );
};

export default Input;
